import styled from 'styled-components';
import { theme, toRem } from 'design';

const TabNav = styled.nav.attrs({ role: 'navigation' })`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: ${toRem(22)};
  gap: ${toRem(5.5)};

  @media (min-width: ${theme.breakpoint.small}px) {
    flex-flow: row nowrap;
    justify-content: flex-start;
    margin-top: ${toRem(13.75)};
  }

  @media (min-width: ${theme.breakpoint.xlarge}px) {
    margin-top: ${toRem(22)};
  }
`;

export default TabNav;
